export const NUTS0 = 'NUTS 0'
export const NUTS1 = 'NUTS 1'
export const NUTS2 = 'NUTS 2'
export const NUTS3 = 'NUTS 3'
export const POPULATION = 'population'
export const LAU2 = 'LAU 2'

export const REGION = 'Region'
export const REGION_GEOSERVER = 'regions'
export const COUNTRY = 'Country'
export const COUNTRY_GEOSERVER = 'boundaries0'
export const SUBDIVISION = 'Sub-division'
export const SUBDIVISION_GEOSERVER = 'boundaries1'

export const HECTARE = 'Hectare'
